var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4931 14.0289C18.4977 13.9199 18.5 13.8102 18.5 13.6998C18.5 9.07934 14.4242 5.59012 9.70087 5.50172C10.8338 3.42864 13.2216 2 15.984 2C19.8411 2 22.968 4.78534 22.968 8.22123C22.968 9.78607 22.3194 11.216 21.2486 12.3092C21.3644 13.4608 21.8643 14.0928 22.9297 14.7313C23.0648 14.8122 22.9899 15.0262 22.8348 14.9973C21.0302 14.6612 20.1183 14.1938 19.5518 13.5706C19.216 13.7486 18.8621 13.9023 18.4931 14.0289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.6998C17 17.4 13.6498 20.3996 9.51716 20.3996C8.12056 20.3996 6.81332 20.057 5.69455 19.4606C5.08756 20.1318 4.1105 20.6351 2.17703 20.9971C2.01081 21.0283 1.93063 20.7978 2.07531 20.7106C3.21678 20.023 3.75242 19.3424 3.87647 18.1023C2.72922 16.9249 2.03431 15.385 2.03431 13.6998C2.03431 9.9996 5.3845 7 9.51716 7C13.6498 7 17 9.9996 17 13.6998ZM6 11.75C5.58579 11.75 5.25 12.0858 5.25 12.5C5.25 12.9142 5.58579 13.25 6 13.25H13C13.4142 13.25 13.75 12.9142 13.75 12.5C13.75 12.0858 13.4142 11.75 13 11.75H6ZM6 14.75C5.58579 14.75 5.25 15.0858 5.25 15.5C5.25 15.9142 5.58579 16.25 6 16.25H10.375C10.7892 16.25 11.125 15.9142 11.125 15.5C11.125 15.0858 10.7892 14.75 10.375 14.75H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble1);
export default __webpack_public_path__ + "static/media/speech-bubble-1.5e78271f487d9923c7aa2b173c50a403.svg";
export { ForwardRef as ReactComponent };